import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

function ConfirmationDialog({ open, onClose, onConfirm }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Biztosan törlöd?</DialogTitle>
            <DialogContent>
                Biztosan törölni szeretnéd?
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Mégse
                </Button>
                <Button onClick={onConfirm} color="primary">
                    Igen
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmationDialog;
